/*
 * @Author: bbqin
 * @Date: 2023-01-10 20:03:34
 * @LastEditTime: 2023-01-11 15:08:53
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\ExtendRouters.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React from 'react';
import { ViewModel } from '@platform/api';

const ExtendRouters = ({ match }) => {
    if (ViewModel) {
        let extendCache = ViewModel.getData('_nccloud_extend_cache_data');
        console.log('客开的路由扩展', extendCache);
        if (extendCache) {
            for (let pop in extendCache) {
                if (extendCache[pop] && extendCache[pop].localExtendRouter) {
                    return extendCache[pop].localExtendRouter(match);
                }
            }
        }
        // return ViewModel.localExtendRouter ? ViewModel.localExtendRouter(match) : <h1>Hello {match.params.extend}!</h1>;
    }
    return null;
};

export default ExtendRouters;